<template>
  <div class="box-container width100 height100">
    <!-- <div class="panel-zoom">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="zoomOut" class="m-l-5"
            >fa-search-minus</v-icon
          >
        </template>
        <span>Zoom out</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="zoomReset" class="m-l-5"
            >fa-search</v-icon
          >
        </template>
        <span>Reset zoom</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="zoomIn">
            fa-search-plus
          </v-icon>
        </template>
        <span>Zoom in</span>
      </v-tooltip>
    </div> -->
    <div id="box-container" class="overflow-x width100 height100">
      <div id="box-chart" class="width100 height100">
        <v-chart
          class="chart"
          autoresize
          :option="polar"
          @contextmenu="viewConver"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { TreeChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  VisualMapComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import variables from '@/styles/variables.scss'

import apiInsight from '@/apis/insight'

use([
  CanvasRenderer,
  TreeChart,
  GridComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent
])

export default {
  props: {
    search: Object,
    count: Number
  },
  components: {
    VChart
  },
  data() {
    return {
      polar: {},
      zoom: 1,
      isExpanded: [],
      rootAmount: 0
    }
  },
  watch: {
    count: {
      immediate: true,
      async handler() {
        await this.chart()
      }
    }
  },
  methods: {
    async getJourney() {
      try {
        const response = await apiInsight.getJourney(this.search)
        const { data } = response

        return data
      } catch (err) {
        return undefined
      } finally {
        this.$emit('closeDialogLoading', null)
      }
    },
    async chart() {
      const json = await this.getJourney()

      if (!json) return

      this.rootAmount = json.value

      const tree = [
        {
          dataIndex: 0
        },
        {
          dataIndex: 1
        }
      ]
      this.isExpanded.push({
        dataIndex: 1,
        generation: -1,
        treeAncestors: tree
      })

      tree.push({
        dataIndex: 2
      })
      this.isExpanded.push({ dataIndex: 2, generation: 0, treeAncestors: tree })
      // json.children.forEach(function(datum, index) {
      //   datum.pin = index
      // })

      const data = this.replaceColorStyle(json)

      this.polar = {
        // silent: true,
        textStyle: {
          fontFamily: variables.fontFamily
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: obj => {
            return `${obj.name}<br><b>${this.percent(
              obj.value
            )}%</b>&nbsp;(${obj.value.toLocaleString()})`
          }
        },
        series: [
          {
            type: 'tree',
            initialTreeDepth: 1,
            data: [data],
            left: 20,
            right: 180,
            top: 20,
            bottom: 20,
            symbolSize: 7,
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left',
              fontSize: 12,
              formatter: obj => {
                return (
                  this.substring(obj.name) +
                  '\n{percent|' +
                  this.percent(obj.value) +
                  '%} {amount|(' +
                  obj.value.toLocaleString() +
                  ')}'
                )
              },
              rich: {
                // name: {
                //   fontSize: 14,
                //   lineHeight: 20
                // },
                amount: {
                  fontSize: 10
                },
                percent: {
                  fontSize: 10,
                  fontWeight: 'bold'
                }
              }
            },
            // lineStyle: {
            //   color: '#d9d9d9',
            //   width: 1
            // },
            itemStyle: {
              color: '#666666'
            },
            leaves: {
              label: {
                position: 'right',
                verticalAlign: 'middle'
              }
            },
            emphasis: {
              focus: 'relative'
            },
            roam: true,
            zoom: 1,
            center: ['40%', '48%'],
            expandAndCollapse: true,
            animationDelay: 450,
            animationDuration: 750,
            animationThreshold: () => {
              return data.value + 1000
            },
            expandAndCollapse: true
          }
        ]
      }
    },
    viewConver(data) {
      const { treeAncestors } = data

      const checkpoints = []
      for (let i = 2; i < treeAncestors.length; i++) {
        checkpoints.push(treeAncestors[i].name)
      }

      const { from, to, channelType, direction, channel } = this.search

      const query = {
        from,
        to,
        type: channelType,
        direction,
        channel,
        checkpoints: JSON.stringify(checkpoints)
      }
      let routeData = this.$router.resolve({
        path: '/conversations',
        query
      })
      window.open(routeData.href, '_blank')

      // const dataIndex = data.dataIndex
      // const generation = data.data.generation
      // const treeAncestors = data.treeAncestors
      // const index = _.findIndex(this.isExpanded, { dataIndex })
      // //collapse
      // if (index > -1) {
      //   const fill = _.filter(this.isExpanded, o => {
      //     if (o.generation > this.isExpanded[index].generation) {
      //       const arr = _.find(o.treeAncestors, { dataIndex })
      //       if (!arr) return o
      //     }
      //   })
      //   const maxGeneration = _.maxBy(fill, 'generation')
      //   if (maxGeneration) this.zoom(maxGeneration.generation)
      //   else this.zoom(this.isExpanded[index].generation)
      //   this.isExpanded.splice(index, 1)
      // }
      // //expand
      // else {
      //   this.isExpanded.push({ dataIndex, generation, treeAncestors })
      //   const fill = _.filter(this.isExpanded, o => {
      //     if (o.generation > generation) {
      //       let isNull = false
      //       for (let i = 0; i < o.treeAncestors.length; i++) {
      //         const t = o.treeAncestors[i]
      //         if (t.dataIndex > 0) {
      //           const check = _.find(this.isExpanded, {
      //             dataIndex: t.dataIndex
      //           })
      //           if (!check) {
      //             isNull = true
      //             i = o.treeAncestors.length
      //           }
      //         }
      //       }
      //       if (!isNull) return o
      //     }
      //   })
      //   const obj = _.maxBy(fill, 'generation')
      //   if (obj) this.zoom(obj.generation)
      //   else this.zoom(generation)
      // }
    },
    replaceColorStyle(data) {
      const text = JSON.parse(JSON.stringify(data), (k, v) =>
        _.isObject(v) ? this.addStyleData(v) : v
      )
      return text
    },
    zoomIn() {
      this.calculateZoom(200)
    },
    zoomOut() {
      this.calculateZoom(-200)
    },
    zoomReset() {
      setTimeout(() => {
        const boxContainer = document.getElementById('box-container')

        const id = document.getElementById('box-chart')
        id.style.width = boxContainer.offsetWidth + 'px'
      }, 200)
    },
    calculateZoom(width) {
      setTimeout(() => {
        const id = document.getElementById('box-chart')
        id.style.width = id.offsetWidth + width + 'px'

        const boxContainer = document.getElementById('box-container')
        boxContainer.scrollLeft = boxContainer.scrollWidth
      }, 200)
    },
    substring(text) {
      return text.length > 25 ? `${text.substring(0, 25)}...` : text
    },
    percent(value) {
      if (!this.rootAmount) return 0

      const num = (value * 100) / this.rootAmount
      return num.toFixed(2)
    },
    addStyleData(obj) {
      if (obj.filter_matched) {
        obj.label = {
          color: '#E33E2C',
          fontSize: 14,
          lineHeight: 16,
          fontWeight: 'bold'
        }
        obj.itemStyle = { color: '#E33E2C' }
      } else {
        obj.label = { fontSize: 14, lineHeight: 16 }
      }

      if (!this.search.checkpoint_name && obj.name === 'Ended By User') {
        obj.itemStyle = { color: '#E33E2C' }
      }

      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.overflow-x {
  overflow-x: auto;
}

.box-container {
  position: relative;
}
.panel-zoom {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  padding: 8px 10px;
  background: transparent;
  // border: 1px solid $primary;
  border-radius: 4px;
  z-index: 5;

  .v-icon {
    color: $text-color !important;
    font-size: 22px;
    margin: 0 5px;

    &:hover {
      color: $primary !important;
    }
  }
}
</style>
